<template>
  <!-- 规则弹窗 -->
  <transition name="fade" mode="out-in">
    <div class="popup rule-popup" v-show="visible">
      <div class="popup-mask" @click="handleClose"></div>
      <div class="popup-content">
        <div class="popup-content-title"></div>
        <div class="popup-content-close" @click="handleClose"></div>
        <div class="popup-content-text" style="white-space: pre-wrap;" v-html="ruleContent"></div>
        <div class="popup-content-confirm-btn" @click="handleClose"></div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue';
import LanguageHook from '@hooks/language';

// 定义props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  content: {
    type: String,
    default: ''
  }
});

// 定义emits
const emit = defineEmits(['update:visible', 'close']);

// 获取语言配置
const { langData } = LanguageHook();

// 规则内容 - 优先使用传入的content，如果没有则使用语言包默认内容
const ruleContent = computed(() => props.content || langData.rulePopupContent || '');

// 关闭弹窗
const handleClose = () => {
  emit('update:visible', false);
  emit('close');
};
</script>

